import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DatabaseProvider } from '../database/database';
import { GraphQLClient } from 'graphql-request';
import moment from 'moment';
import { Variables, ClientError } from 'graphql-request/dist/src/types';
import { boostrapConfig } from '../../config';
import { AppState } from '../../config/state';

/*
  Generated class for the ApiProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ApiProvider {
  private apiUrl = boostrapConfig.api.url;
  private currentToken: APItoken;

  constructor(public http: HttpClient, private db: DatabaseProvider, private state:AppState ) {}
  private generateNewToken():Promise<APItoken> {
    console.log('generating new token');
    const body = new HttpParams()
    .set('grant_type', 'client_credentials')
    .set('client_id', this.state.authentication.key)
    .set('client_secret', this.state.authentication.secret);

    let self = this;
    return this.http.post(this.apiUrl+'/token', body.toString(), {
      responseType:'json',
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
    }).toPromise().then((token:APItoken)=>{
      token.expireTime = moment().add(token.expires_in, 'seconds').toISOString();
      self.db.set('ApiProvider:token', token);
      return token;
    });
  }
  private isTokenValid(token:APItoken):boolean{
    return (token && token.expireTime && moment(token.expireTime) > moment());
  }
  public async resetToken() {
    this.currentToken = await this.generateNewToken();
    return true;
  }
  private async getToken():Promise<any>{
    if(this.isTokenValid(this.currentToken))return this.currentToken;
    // this.currentToken = await this.db.get('ApiProvider:token');
    // if(this.isTokenValid(this.currentToken))return this.currentToken;
    this.currentToken = await this.generateNewToken();
    return this.currentToken;
  }
  public async query(query:string, variables?:Variables):Promise<any> {
    let token:APItoken = await this.getToken();
    return new GraphQLClient(this.apiUrl+'/graphql', { headers: {'Authorization':`Bearer ${token.access_token}`} })
      .request(query, variables).catch((err:ClientError)=>{
        this.currentToken = null;
		    console.info(err);
        if(err.response && err.response.errors) console.log("Query failed", err.response.errors[0].message);
        if(err.response && err.response.data) {
          return err.response.data;
        } else return null;
      });
  }
  public async getData(query, idField:string, id:any, cachedTime?: number){
    const queryName = query.match(/[\w\d]+/)[0];
    if(!cachedTime)cachedTime = this.state.cacheTime;
    const find = {};
    find[idField]=id
    const collection = this.db.getCollection(queryName);
    collection.ensureUniqueIndex('id');
    let data = await collection.findOne(find);
    if (data && moment().diff(data.cachedTime, 'seconds') < cachedTime) {
      return data;
    }

    data = await this.query(query);

    if(data && data[queryName]){
      const item = data[queryName];
      item.cachedTime = moment().toISOString();
      collection.chain().find(find).remove();
      collection.insertOne(item);
      await this.db.saveDB();
      return item;
    }else{
      return null;
    }
  }
  public async getDataArray(query, idField:string, id?:any, cachedTime?: number, collectionName?:string){
    const queryName = query.match(/[\w\d]+/)[0];
    if(!cachedTime)cachedTime = this.state.cacheTime;
    const collection = this.db.getCollection(collectionName || queryName);
    collection.ensureUniqueIndex('id');
    let data;
    if(id && idField){
      const selector={};
      selector[idField] = id;
      data = await collection.find(selector).filter(item=>moment().diff(item.cachedTime, 'seconds') < cachedTime);
    }else{
      data = await collection.where((item)=>true).filter(item=>moment().diff(item.cachedTime, 'seconds') < cachedTime);
    }
    if (data && data.length>0) {
      return data;
    }
    const results = await this.query(query);

    if(results && results[queryName]){
      results[queryName].forEach(result => {
        result.cachedTime = moment().toISOString();
        const find = {};
        find[idField]=result[idField];
        collection.chain().find(find).remove();
        try {
          collection.insertOne(result);
        } catch (ex) {
          console.log(ex);
        }
      });
      await this.db.saveDB();
      return results[queryName];
    }else{
      return null;
    }
  }

}

interface APItoken {
  access_token: string;
  token_type: string;
  expires_in: number;
  expireTime: string;
}


// WEBPACK FOOTER //
// ./src/providers/api/api.ts